import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, Subject, Subscription, filter, takeUntil } from "rxjs";
import { selectTemplatesList } from "../../../account-info-header/reducers";
import { DraftCommonWire } from "../../../create-request/models/wire/WireTemplatesResponse";
import { NamePipe } from "../../pipes/NamePipe";
import { deleteTemplate } from "../../../create-request/actions/transactions-table-actions";
import { ViewDetails } from "../../../transaction-view/models/ViewDetails";

@Component({
  standalone: false,
    selector: 'mm-delete-template-modal',
    templateUrl: './delete-template-modal.component.html',
    styleUrls: ['./delete-template-modal.component.scss']
})

export class DeleteTemplateModalComponent implements OnInit, OnDestroy {
    @Input() showModal$: Observable<boolean>;
    @Input() currentTemplate$: Observable<string | null>;
    showModalSub: Subscription;
    textBody: string = 'Are you sure you want to delete this template? This action cannot be undone.';
    title: string = 'Delete this template?'
    destroy$: Subject<boolean> = new Subject<boolean>();
    modal: EverestModal;
    deleteTemplateClicked: boolean = false;
    templateList: DraftCommonWire[];
    draftId: string;
    templateToDelete: DraftCommonWire | undefined;
    transactionType: string;
    nickname: string;
    bankAba: string;
    bankAddress: string;
    bankAddressTwo: string;
    recipientParty: string;
    viewDetails$: Observable<ViewDetails>;

    @Output() deleteTemplateeModalClosed = new EventEmitter<{
        goBack: boolean;
        deleteTemplateClicked: boolean;
    }>();

    constructor(private store: Store, private namePipe: NamePipe) {}

    ngOnInit(): void {
        this.showModalSub = this.showModal$.subscribe((show) => {
            this.modal = document.getElementById('delete-template-modal') as EverestModal;
            if (show) this.modal.showModal();
        });

        this.store.select(selectTemplatesList).pipe(takeUntil(this.destroy$)).subscribe(templateList => {
            this.templateList = templateList
        });

        this.currentTemplate$.pipe(takeUntil(this.destroy$)).subscribe((draftId) => {
            this.draftId = draftId ?? '';

            this.templateToDelete = this.templateList.find(template => template.draftId === this.draftId);

            if (this.templateToDelete) {
                this.transactionType = this.namePipe.transform(this.templateToDelete.transactionType);
                this.nickname = this.templateToDelete.draftObject.nickname;
                this.bankAba = this.templateToDelete.draftObject.beneficiaryBankId;
                this.bankAddress = this.namePipe.transform(this.templateToDelete.draftObject.beneficiaryBank.addressLineOne);
                this.bankAddressTwo = this.namePipe.transform(this.templateToDelete.draftObject.beneficiaryBank.addressLineTwo);
                this.recipientParty = this.templateToDelete.draftObject.isThirdParty ? 'Third party' : 'First party';
            }
        })
    }

    ngOnDestroy(): void {
        this.showModalSub?.unsubscribe();
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    onModalClose(event: any) {
        this.deleteTemplateeModalClosed.emit({
            goBack: true,
            deleteTemplateClicked: this.deleteTemplateClicked,
        });
    }

    onGoBackClick() {
        this.modal.hideModal();
    }

    onDeleteTemplateClick() {
        this.deleteTemplateClicked = true;
        this.store.dispatch(deleteTemplate({ id: this.draftId }));
        this.modal.hideModal();
    }
    
}

type EverestModal = HTMLElement & {
    showModal: () => {},
    hideModal: () => {}
};